import environments from '@utils/environments';
import mixpanel, { Config } from 'mixpanel-browser';
import './types';

const mixpanelConfig: Partial<Config> = {};
if (environments.isLocal() || environments.isDev()) {
  mixpanelConfig.debug = true;
  mixpanelConfig.opt_out_tracking_by_default = true;
}
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string, mixpanelConfig);
